export function appendSqidSearchParam(url: string, sqid: string): string {
	const trimmedSqid = sqid.trim();
	if (!trimmedSqid) {
		return url;
	}

	const hashIndex = url.indexOf("#");
	const beforeHash = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
	const hash = hashIndex >= 0 ? url.slice(hashIndex) : "";

	const queryIndex = beforeHash.indexOf("?");
	const pathname =
		queryIndex >= 0 ? beforeHash.slice(0, queryIndex) : beforeHash;
	const query = queryIndex >= 0 ? beforeHash.slice(queryIndex + 1) : "";

	const params = new URLSearchParams(query);
	params.set("sqid", trimmedSqid);
	const nextQuery = params.toString();
	return `${pathname}${nextQuery ? `?${nextQuery}` : ""}${hash}`;
}
